import type React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    GradientEllipse,
    PageSplit,
    PageSplitAside,
    PageSplitBody,
    PageSplitHeader,
    PageSplitMain,
} from '@gitbook/spine-react';

import { DocsPreview } from '../../Components/Welcome/DocsPreview';

export function LoginScreenLayout(props: { children: React.ReactNode; onClose?: () => void }) {
    const { children, onClose } = props;

    return (
        <PageSplit>
            <PageSplitMain>
                {onClose ? (
                    <PageSplitHeader>
                        <Button
                            label="Back"
                            kind="secondary"
                            leadingIcon={Icon.ArrowLeft}
                            iconOnly
                            onPress={onClose}
                            className="m-4"
                        />
                    </PageSplitHeader>
                ) : null}
                <PageSplitBody size="medium">{children}</PageSplitBody>
            </PageSplitMain>
            <PageSplitAside
                className="overflow-visible"
                customGradient={
                    <GradientEllipse className="pointer-events-none absolute top-0 left-12 size-full scale-[2] xl:pt-20 dark:opacity-50" />
                }
            >
                <DocsPreview />
            </PageSplitAside>
        </PageSplit>
    );
}
